"use strict";

import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import React from 'react';
import LoginFormStore from "Stores/Login/LoginFormStore";
import { login } from "Actions/Login/LoginFormActions";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Person from '@material-ui/icons/Person';
import Lock from '@material-ui/icons/Lock';
import Typography from '@material-ui/core/Typography';
import { Messages } from 'Messages';
import { getSystemParam } from "D5Utils/functions";

var styles = function styles(theme) {
  return {
    textField: {
      width: '100%',
      marginTop: theme.spacing.unit * 3
    },
    buttonWrapper: {
      marginTop: theme.spacing.unit * 6,
      marginBottom: theme.spacing.unit * 5
    },
    caption: {
      marginTop: theme.spacing.unit * 3,
      textAlign: 'center',
      fontSize: '1.5rem',
      fontWeight: 700,
      color: '#6b8d9f'
    },
    buttonRoot: {
      height: theme.spacing.unit * 6,
      textTransform: 'none'
    },
    inputWrapper: {
      paddingLeft: theme.spacing.unit * 3,
      paddingRight: theme.spacing.unit * 3
    },
    lightGreyColor: {},
    inputClass: {
      '&:before': {// backgroundColor: 'rgba(107, 141, 159, 0.25)'
      }
    }
  };
};

var LoginForm =
/*#__PURE__*/
function (_React$Component) {
  _inherits(LoginForm, _React$Component);

  function LoginForm(props) {
    var _this;

    _classCallCheck(this, LoginForm);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LoginForm).call(this, props));
    _this._onChange = _this._onChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.state = LoginFormStore.getList();
    return _this;
  }

  _createClass(LoginForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      LoginFormStore.addChangeListener(this._onChange);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      LoginFormStore.removeChangeListener(this._onChange);
    }
  }, {
    key: "_onChange",
    value: function _onChange() {
      this.setState(LoginFormStore.getList());
    }
  }, {
    key: "_handleKeyEnter",
    value: function _handleKeyEnter(e) {
      if (e.key === 'Enter') {
        this.doLogin();
      }
    }
  }, {
    key: "onInputsChange",
    value: function onInputsChange(event, name) {
      this.setState(_defineProperty({}, name, event.target.value));
    }
  }, {
    key: "doLogin",
    value: function doLogin() {
      login(this.state.login, this.state.password);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var classes = this.props.classes;
      var loginTitle = getSystemParam('MainForm', 'LoginTitle');
      return React.createElement("div", null, React.createElement(Grid, {
        container: true
      }, React.createElement(Grid, {
        item: true,
        xs: 12
      }, React.createElement(Typography, {
        variant: "h5",
        className: classes.caption
      }, loginTitle)), React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.inputWrapper
      }, React.createElement(TextField, {
        id: "login",
        label: Messages.Controls.Login,
        error: !this.state.isLoginValid,
        helperText: !this.state.isLoginValid ? "The Field should not be empty or contains any whitespaces." : '',
        className: classes.textField,
        onChange: function onChange(e) {
          return _this2.onInputsChange(e, 'login');
        },
        autoFocus: true,
        InputProps: {
          startAdornment: React.createElement(InputAdornment, {
            position: "start"
          }, React.createElement(Person, {
            color: "disabled",
            classes: {
              colorDisabled: classes.lightGreyColor
            }
          })),
          className: classes.inputClass
        },
        InputLabelProps: {
          className: classes.lightGreyColor
        }
      })), React.createElement(Grid, {
        item: true,
        className: classes.inputWrapper,
        xs: 12
      }, React.createElement(TextField, {
        error: !this.state.isPassValid,
        helperText: !this.state.isPassValid ? "The Field should not be empty and contains less then 6 symbols." : '',
        id: "password",
        type: "password",
        label: Messages.Controls.Password,
        className: classes.textField,
        autoComplete: "current-password",
        onChange: function onChange(e) {
          return _this2.onInputsChange(e, 'password');
        },
        onKeyPress: function onKeyPress(e) {
          _this2._handleKeyEnter(e);
        },
        InputProps: {
          startAdornment: React.createElement(InputAdornment, {
            position: "start"
          }, React.createElement(Lock, {
            color: "disabled",
            classes: {
              colorDisabled: classes.lightGreyColor
            }
          })),
          className: classes.inputClass
        },
        InputLabelProps: {
          className: classes.lightGreyColor
        }
      })), React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.buttonWrapper
      }, React.createElement(Button, {
        fullWidth: true,
        variant: "contained",
        color: "primary",
        classes: {
          root: classes.buttonRoot
        },
        onClick: this.doLogin.bind(this)
      }, Messages.Controls.SingIn))));
    }
  }]);

  return LoginForm;
}(React.Component);

LoginForm.propTypes = {
  classes: PropTypes.object.isRequired
};
export default withStyles(styles)(LoginForm);